<template>
  <v-navigation-drawer
    class="detail-drawer"
    :value="value"
    right
    temporary
    stateless
    fixed
    :width="width"
    @input="$emit('input', $event)"
  >
    <div class="detail-drawer__head">
      <div>
        <div class="detail-drawer__title">
          {{ title }}
        </div>
        <div
          v-if="subtitle"
          class="detail-drawer__subtitle"
        >
          {{ subtitle }}
        </div>
      </div>
      <button
        type="button"
        class="detail-drawer__close"
        aria-label="Fechar"
        @click="$emit('input', false)"
      >
        ✕
      </button>
    </div>
    <div class="detail-drawer__body">
      <slot />
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'BaseDetailDrawer',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false,
      default: ''
    },
    width: {
      type: String,
      required: false,
      default: '68%'
    }
  }
}
</script>

<style lang="scss">
.detail-drawer {
  &.v-navigation-drawer .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  &__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    padding: 16px 24px;
    border-bottom: 1px solid var(--ds-color-black-010);
    flex: none;
  }

  &__title {
    font-size: 0.875rem;
    font-weight: 700;
    margin-bottom: 2px;
    color: var(--v-textPrimary-base);
  }

  &__subtitle {
    font-size: 0.8rem;
    color: var(--ds-color-black-055);
  }

  &__close {
    cursor: pointer;
    background: none;
    border: none;
    color: var(--ds-color-black-055);
    font-size: 16px;
    line-height: 1;
    padding: 3px 7px;
    border-radius: 4px;
    flex: none;

    &:hover {
      background: var(--ds-color-black-005);
      color: var(--ds-color-black-085);
    }
  }

  &__body {
    padding: 24px;
    overflow-y: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}
</style>
